import Storage from 'utils/localStorage/Storage';

// The GLADLY_HANDOFF frame from SuperChat carries a `data.summary` markdown string
// (customer-facing bubble text) plus `data.chat_summary` (agent-facing situational context)
// and `data.user_request` (the shopper's original message). These must be seeded into the
// Gladly transcript once GladChat has finished its own show/login dance. SuperChat and GladChat
// are siblings and cannot pass this via props, so the payload lives in sessionStorage across the
// widget swap. Session (not local) because a handoff is a per-tab intent and must not survive
// tab close.
const HANDOFF_SUMMARY_KEY = 'sephora.gladlyHandoffSummary';

/**
 * Persist the SuperChat handoff payload so GladChat can consume it once the Gladly widget is open.
 * No-op when `summary` is missing (nothing to hand off); `chatSummary`/`userRequest` default to null.
 *
 * @param {Object} params
 * @param {string} params.summary - Customer-facing handoff bubble text from the GLADLY_HANDOFF frame.
 * @param {string} [params.chatSummary] - Agent-facing situational context for the receiving agent.
 * @param {string} [params.userRequest] - The shopper's original request, seeded into the Gladly transcript.
 */
const setHandoffSummary = ({ summary, chatSummary, userRequest } = {}) => {
    if (!summary) {
        return;
    }

    Storage.session.setItem(HANDOFF_SUMMARY_KEY, {
        summary,
        chatSummary: chatSummary || null,
        userRequest: userRequest || null
    });
};

const getHandoffSummary = () => Storage.session.getItem(HANDOFF_SUMMARY_KEY) || null;

const clearHandoffSummary = () => Storage.session.removeItem(HANDOFF_SUMMARY_KEY);

export {
    HANDOFF_SUMMARY_KEY, setHandoffSummary, getHandoffSummary, clearHandoffSummary
};
